




import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductOptionValue } from '@/models/catalog/ProductOptionValue';
import { isWhite } from '@/services/ColorService';

@Component
export default class ColorDisplay extends Vue {
    @Prop()
    public value!: ProductOptionValue;

    @Prop({ default: false })
    public inline!: boolean;

    public isColorWhite(input: string) {
        return isWhite(input);
    }
}
